<div *ngIf="item.customField22 == '1' ">
    <div style="margin-top: 50px;font-size: 20px;margin-bottom: 15px;" fxLayoutAlign="center center">
        Annual &#160;&#160;
        <mat-slide-toggle [(ngModel)]="isChecked" (change)="toggleChanged()" color="primary">Lifetime</mat-slide-toggle>
    </div>

    <div fxLayout="column" fxLayout.gt-sm="row" style="text-align: center;" fxLayoutGap="15px"
        *ngFor="let data of pricedetail">
        <div contentAnim [aniName]="item.customField36" fxFlex="100" fxFlex.gt-sm="33" style="border: 1px solid gray;border-radius: 20px">
            <h3><b>{{data.title1}}</b></h3>
            <p> For growing businesses with a comprehensive set of features</p>

            <div *ngIf="!isChecked">
                <h4><b>₹ {{data.s_price_annualy}} /&#160;&#160;&#160;Yearly</b></h4>
                <h6>{{data.s_charge_year}}</h6>
            </div>
            <div *ngIf="isChecked">
                <h4><b>₹ {{data.s_price_life}}/​ &#160;&#160;&#160;lifetime</b></h4>
                <h6>Annual maintenance charge : ₹ {{data.s_charge_life}}</h6>
            </div>

            <button (click)="openInNewWindow(data.p_button)" mat-raised-button
                color="primary">{{data.s_button}}</button>
            <h5><b>{{data.s_subtitle}}</b></h5>

            <div *ngFor="let subdata of data.list_detail" style="margin-bottom: 10px;">
                <div class="pricelist" *ngIf="subdata.starters">
                    <mat-icon class="maticon3">check_circle</mat-icon>
                    <h6 style="margin-bottom: 0px;">&#160;&#160;{{subdata.starters}}</h6>
                </div>
            </div>
            <!-- <div>
                <div class="pricelist" >
                    <mat-icon class="maticon3">check_circle</mat-icon>
                    <h6 style="margin-bottom: 0px;">&#160;Partial Payment</h6>                
                </div>
            </div> -->
        </div>

        <div contentAnim [aniName]="item.customField37" fxFlex="100" fxFlex.gt-sm="33" [style.background-color]="data.a_button"
            style="border: 1px solid gray;border-radius: 20px;" class="txtcolor">
            <h3><b>{{data.title2}}</b></h3>
            <p>Professional features to grow and manage your online store</p>

            <div *ngIf="!isChecked">
                <h4><b>₹ {{data.p_price_annualy}} /&#160;&#160;&#160;Yearly</b></h4>
                <h6 class="txtcolor">{{data.p_charge_year}}</h6>
            </div>
            <div *ngIf="isChecked">
                <h4><b>₹ {{data.p_price_life}}/​ &#160;&#160;&#160;lifetime</b></h4>
                <h6 class="txtcolor"> Annual maintenance charge : ₹ {{data.p_charge_life}}</h6>
            </div>

            <button (click)="openInNewWindow(data.p_button)" mat-raised-button>{{data.s_button}}</button>
            <h5 class="txtcolor"><b>{{data.p_subtitle}}</b></h5>

            <div *ngFor="let subdatas of data.list_detail" style="margin-bottom: 10px;">
                <div class="pricelist" *ngIf="subdatas.professions">
                    <mat-icon class="maticon3">check_circle</mat-icon>
                    <h6 style="margin-bottom: 0px;" class="txtcolor">&#160;&#160;{{subdatas.professions}}</h6>
                </div>
            </div>

        </div>

        <div contentAnim [aniName]="item.customField38" fxFlex="100" fxFlex.gt-sm="33" style="border: 1px solid gray;border-radius: 20px">
            <h3><b>{{data.title3}}</b></h3>
            <p>Ideal for established businesses with high-volume sales & Multiple Outlets</p>

            <div *ngIf="!isChecked">
                <h4><b>₹ {{data.a_price_annualy}} /&#160;&#160;&#160;Yearly</b></h4>
                <h6>{{data.a_charge_year}}</h6>
            </div>
            <div *ngIf="isChecked">
                <h4><b>₹ {{data.a_price_life}}/​ &#160;&#160;&#160;lifetime</b></h4>
                <h6>Annual maintenance charge : ₹ {{data.a_charge_life}}</h6>
            </div>

            <button (click)="openInNewWindow(data.p_button)" mat-raised-button
                color="primary">{{data.s_button}}</button>
            <h5><b>{{data.a_subtitle}}</b></h5>

            <div *ngFor="let subdataz of data.list_detail" style="margin-bottom: 10px;">
                <div class="pricelist" *ngIf="subdataz.advanceds">
                    <mat-icon class="maticon3">check_circle</mat-icon>
                    <h6 style="margin-bottom: 0px;">&#160;&#160;{{subdataz.advanceds}}</h6>
                </div>
            </div>

        </div>
    </div>

</div>

<!----------- TYpe 2 ------------>


<div *ngIf="item.customField22 == '2' ">

    <div fxLayout="column" fxLayout.gt-sm="row" style="text-align: center;" fxLayoutGap="15px"
        *ngFor="let data of pricedetail">
        <div contentAnim [aniName]="item.customField36" fxFlex="100" fxFlex.gt-sm="33" style="border: 1px solid gray;border-radius: 20px">
            <h3><b>{{data.title1}}</b></h3>

            <div>
                <h4><b>₹ {{data.s_price_annualy}} </b></h4>
                <h6>{{data.s_charge_year}}</h6>
            </div>

            <button (click)="openInNewWindow(data.p_button)" mat-raised-button
                color="primary">{{data.s_button}}</button>
            <h5><b>{{data.s_subtitle}}</b></h5>

            <div *ngFor="let subdata of data.list_detail" style="margin-bottom: 10px;">
                <div class="pricelist" *ngIf="subdata.starters">
                    <div fxLayout="row" fxLayoutAlign="start start">
                        <div>
                    <mat-icon class="maticon3">check_circle</mat-icon>
                </div>
                <div>
                    <h6 style="margin-bottom: 0px;font-size: 16px">&#160;{{subdata.starters}}</h6>
                </div>
                    </div>
                </div>
            </div>
        </div>

        <div contentAnim [aniName]="item.customField37" fxFlex="100" fxFlex.gt-sm="33" [style.background-color]="data.a_button"
            style="border: 1px solid gray;border-radius: 20px;" class="txtcolor">
            <h3><b>{{data.title2}}</b></h3>

            <div>
                <h4><b>₹ {{data.p_price_annualy}}</b></h4>
                <h6 class="txtcolor">{{data.p_charge_year}}</h6>
            </div>

            <button (click)="openInNewWindow(data.p_button)" mat-raised-button>{{data.s_button}}</button>
            <h5 class="txtcolor"><b>{{data.p_subtitle}}</b></h5>

            <div *ngFor="let subdatas of data.list_detail" style="margin-bottom: 10px;">
                <div class="pricelist" *ngIf="subdatas.professions">
                    <div fxLayout="row" fxLayoutAlign="start start">
                        <div>
                            <div class="circleiconz">
                                <mat-icon class="maticon_3">check_circle</mat-icon>
                            </div>
                        </div>
                        <div>
                    <h6 style="margin-bottom: 0px;padding-left: 10px;font-size: 16px" class="txtcolor">&#160;{{subdatas.professions}}</h6>
                </div>
                    </div>
                </div>
            </div>

        </div>

        <div contentAnim [aniName]="item.customField38" fxFlex="100" fxFlex.gt-sm="33" style="border: 1px solid gray;border-radius: 20px">
            <h3><b>{{data.title3}}</b></h3>

            <h4><b>₹ {{data.a_price_annualy}} </b></h4>
            <h6>{{data.a_charge_year}}</h6>

            <button (click)="openInNewWindow(data.p_button)" mat-raised-button
                color="primary">{{data.s_button}}</button>
            <h5><b>{{data.a_subtitle}}</b></h5>

            <div *ngFor="let subdataz of data.list_detail" style="margin-bottom: 10px;">
                <div class="pricelist" *ngIf="subdataz.advanceds">
                    <div fxLayout="row" fxLayoutAlign="start start">
                        <div>
                            <mat-icon class="maticon3">check_circle</mat-icon>
                        </div>
                        <div>
                            <h6 style="margin-bottom: 0px;font-size: 16px;">&#160;{{subdataz.advanceds}}</h6>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

</div>


<div *ngIf="item.customField22 == '3' ">
<div class="pricing-container">
    <div class="pricing-card">
        <h3><b>STARTER</b></h3>
        <p class="plan-tagline">Ideal for individuals and small teams.</p>
        <h5><b>5 USERS INCLUDED</b></h5>
        <h4><b>₹ 10000</b></h4>
        <p class="billing-info">One-time payment</p>
        <div class="features-list">
            <ul>
                <li>
                    <mat-icon class="maticon3">check_circle</mat-icon>
                    <h6>No extra cost for adding up to 5 users</h6>
                </li>
                <li>
                    <mat-icon class="maticon3">check_circle</mat-icon>
                    <h6>Store up to 40,000 Leads</h6>
                </li>
                <li class="feature-limited">
                    <mat-icon class="maticon3">cancel</mat-icon>
                    <h6>No Customization</h6>
                </li>
                 <li>
                    <mat-icon class="maticon3">cancel</mat-icon>
                    <h6>Standard Support</h6>
                </li>
            </ul>
        </div>
        <div class="cta-button">
            <button (click)="scrollDown('seocrm')" mat-raised-button color="primary">Book a Demo</button>
        </div>
    </div>

    <div class="pricing-card highlighted">
        <h3><b>PROFESSIONAL</b></h3>
        <p class="plan-tagline">Best for growing businesses with advanced needs.</p>
        <h5><b>1 USERS</b></h5>
        <!-- <h4><b>₹ 250<span> / Month</span></b></h4>
        <p class="billing-info">Billed Annually</p> -->
        <h4><b>₹ 500<span> / Month</span></b></h4>
        <p class="billing-info">Billed Annually</p>
        <div class="features-list">
            <ul>
                <li>
                    <mat-icon class="maticon3">check_circle</mat-icon>
                    <h6>1 user ₹ 800 /month billed half-yearly</h6>
                </li>
                <li>
                    <mat-icon class="maticon3">check_circle</mat-icon>
                    <h6>Store up to 50,000 leads</h6>
                </li>
                <li>
                    <mat-icon class="maticon3">check_circle</mat-icon>
                    <h6>Customization With Additional Pricing</h6>
                </li>
                <li>
                    <mat-icon class="maticon3">check_circle</mat-icon>
                    <h6>Priority Support</h6>
                </li>
            </ul>
        </div>
        <div class="cta-button">
            <button (click)="scrollDown('seocrm')" mat-raised-button color="primary">Book a Demo</button>
        </div>
    </div>

    <div class="pricing-card">
        <h3><b>UNLIMITED</b></h3>
        <p class="plan-tagline">Comprehensive features for large enterprises.</p>
        <h5><b>UNLIMITED USERS</b></h5>
        <h4><b>₹ 11999<span>/ Month</span></b></h4>
        <p class="billing-info">Billed Annually</p>
        <div class="features-list">
            <ul>
                <li>
                    <mat-icon class="maticon3">check_circle</mat-icon>
                    <h6>Store up to 100,000 Leads</h6>
                </li>
                <li>
                    <mat-icon class="maticon3">check_circle</mat-icon>
                    <h6>Customization With Additional Pricing</h6>
                </li>
                <li>
                    <mat-icon class="maticon3">check_circle</mat-icon>
                    <h6>Dedicated Support</h6>
                </li>
                <li>
                    <mat-icon class="maticon3">check_circle</mat-icon>
                    <h6>Advanced Reporting</h6>
                </li>
            </ul>
        </div>
        <div class="cta-button">
            <button (click)="scrollDown('seocrm')" mat-raised-button color="primary">Book a Demo</button>
        </div>
    </div>

    <div class="pricing-card highlighted">
        <h3><b>UNLIMITED MAX</b></h3>
        <p class="plan-tagline">Ultimate solution for extensive lead management.</p>
        <h5><b>UNLIMITED USERS</b></h5>
        <h4><b>₹ 70000<span>/ Month</span></b></h4>
        <p class="billing-info">Billed Annually</p>
        <div class="features-list">
            <ul>
                <li>
                    <mat-icon class="maticon3">check_circle</mat-icon>
                    <h6>Store up to 1,100,000 Leads</h6>
                </li>
                <li>
                    <mat-icon class="maticon3">check_circle</mat-icon>
                    <h6>Basic Customization Included</h6>
                </li>
                <li>
                    <mat-icon class="maticon3">check_circle</mat-icon>
                    <h6>Premium 24/7 Support</h6>
                </li>
                <li>
                    <mat-icon class="maticon3">check_circle</mat-icon>
                    <h6>On-demand Training</h6>
                </li>
            </ul>
        </div>
        <div class="cta-button">
            <button (click)="scrollDown('seocrm')" mat-raised-button color="primary">Book a Demo</button>
        </div>
    </div>
</div>
<div class="feature-compare-banner" fxLayout="row" fxLayoutAlign="end center">
  <a href="{{data.p_button}}" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="12px"  *ngFor="let data of pricedetail">
    <div class="compare-text">
      {{data.s_button}}
    </div>
    <button mat-icon-button class="round-blue-icon">
      <mat-icon>arrow_forward</mat-icon>
    </button>
</a>
</div>


</div>